<div class="rounded-lg shadow w-4/12 h-full fixed right-0 top-0 z-40 p-16">
  <div
    class="bg-white rounded-lg w-full h-full m-0 border-2 border-gray-400 p-16"
  >
    <div class="flex justify-end mb-9">
      <div
        (click)="changeLayoutMode('OrganizationalChart')"
        *ngIf="layoutMode == 'HierarchicalTree'"
        class="
          rounded-full
          cursor-pointer
          shadow-xl
          bg-red-500
          text-center
          inline-flex
          justify-center
          items-center
          p-3
        "
      >
        <img style="height: 30px" src="assets/icons/diagram.png" alt="" />
      </div>
      <div
        (click)="changeLayoutMode('HierarchicalTree')"
        *ngIf="layoutMode == 'OrganizationalChart'"
        class="
          cursor-pointer
          rounded-full
          shadow-xl
          bg-red-500
          text-center
          inline-flex
          justify-center
          items-center
          p-3
        "
      >
        <img style="height: 30px" src="assets/icons/diagram2.png" alt="" />
      </div>
    </div>
    <div class="flex flex-col">
      <div class="scroll Parent">
        <div
          class="vl-b"
          [style]="'height: calc(60px *' + node.Parent.length + ')'"
          style="bottom: 40px"
        ></div>
        <div class="text-center z-10 flex items-center justify-center">
          <div
            (click)="showAddParent = true"
            *ngIf="!showAddParent"
            style="width: 45px; height: 45px"
            class="
              cursor-pointer
              rounded-full
              bg-white
              font-bold
              border-2 border-blue-600
              text-3xl text-blue-600
              flex
              justify-center
              items-center
            "
          >
            +
          </div>
          <div
            [style]="showAddParent ? 'display:unset;' : 'display:none;'"
            class="w-full"
          >
            <!-- <unilog-recherche
            class="z-10 w-full"
            recherche="avtperso"
            champsModel="Perso_Matricule"
            champsAffiche="Perso_Nom"
            formControlName="Perso_Matricule"
            appearance="outline"
            label="Vendeur"
            [ServerSideFiltering]="true"
            textErreur="Veuillez Entrer Vendeur valide"
            [showError]="true"
            [api]="generalService.api"
            placeholder="Vendeur"
            [(ngModel)]="newParent"
          >
          </unilog-recherche> -->
            <input
              (keydown.enter)="submit()"
              type="text"
              [(ngModel)]="newParent"
              class="
                z-10
                w-full
                rounded
                border-2 border-blue-600
                text-3xl text-center text-blue-700
                py-2
              "
            />
          </div>
        </div>
        <ng-container *ngFor="let parent of node.Parent">
          <div
            (click)="showAddParent = showAddChild = false"
            *ngIf="parent != ''"
            class="
              bg-blue-600
              my-8
              rounded
              text-white text-center text-3xl
              py-10
              z-10
            "
          >
            {{ parent }}
          </div>
        </ng-container>
      </div>
      <div
        class="relative flex flex-col"
        style="margin-top: -9px"
        (click)="showAddParent = showAddChild = false"
      >
        <div class="vl-b" style="height: 20px; margin-top: -20px"></div>
        <div
          class="
            bg-red-600
            mx-16
            rounded
            text-white text-center text-3xl
            py-10
            z-10
          "
        >
          {{ node.Name }}
        </div>
        <div
          class="vl-g"
          style="height: 20px; margin-bottom: -20px; bottom: 0"
        ></div>
      </div>
      <div class="scroll" style="padding-top: 15px">
        <div class="text-center z-10 flex items-center justify-center">
          <div
            (click)="showAddChild = true"
            *ngIf="!showAddChild"
            style="width: 45px; height: 45px"
            class="
              cursor-pointer
              rounded-full
              bg-white
              font-bold
              border-2 border-green-600
              text-3xl text-green-600
              flex
              justify-center
              items-center
            "
          >
            +
          </div>
          <div
            [style]="showAddChild ? 'display:unset;' : 'display:none;'"
            class="w-full"
          >
            <!-- <unilog-recherche
            class="z-10 w-full"
            recherche="avtperso"
            champsModel="Perso_Matricule"
            champsAffiche="Perso_Nom"
            formControlName="Perso_Matricule"
            appearance="outline"
            label="Vendeur"
            [ServerSideFiltering]="true"
            textErreur="Veuillez Entrer Vendeur valide"
            [showError]="true"
            [api]="generalService.api"
            placeholder="Vendeur"
            [(ngModel)]="newChild"
          >
          </unilog-recherche> -->
            <input
              (keydown.enter)="submit()"
              type="text"
              [(ngModel)]="newChild"
              class="
                z-10
                w-full
                rounded
                border-2 border-green-600
                text-3xl text-center text-green-700
                py-2
              "
            />
          </div>
        </div>
        <div
          class="vl-g"
          [style]="'height: calc(60px *' + node.childs.length + ')'"
          style="bottom: 40px"
        ></div>
        <div
          (click)="showAddParent = showAddChild = false"
          *ngFor="let child of node.childs"
          class="
            bg-green-600
            my-8
            rounded
            text-white text-center text-3xl
            py-10
            z-10
          "
        >
          {{ child }}
        </div>
      </div>
    </div>
    <div class="flex justify-end">
      <button
        *ngIf="
          (showAddParent && newParent != '') || (showAddChild && newChild != '')
        "
        class="bg-blue-800 px-16 py-8 rounded text-white"
        (click)="submit()"
      >
        Ajouter
      </button>
      <button
        *ngIf="unsavedChanges"
        class="bg-green-800 px-16 py-8 rounded text-white ml-5"
        (click)="close()"
      >
        Enregistrer
      </button>
    </div>
    <div class="h-20"></div>
  </div>
</div>
